import React, {Component} from 'react';

import GoToYear from "./catalog/GoToYear.jsx";
import ListWorksets from "./catalog/ListWorksets.jsx";
import {SectionTitle, ContentWrapper} from './../util/Styles.jsx'

export class EditCatalog extends Component {

    static propTypes = {}

    state = {
        year: 2021
    };

    go_to_year(year) {
        this.setState({year: parseInt(year)});
    }

    render() {
        const catalog_title = <SectionTitle>Catalog of Works</SectionTitle>
        const go_to_year = <GoToYear callback={year => this.go_to_year(year)}/>
        const list_worksets = <ListWorksets year={this.state.year}/>
        return <ContentWrapper>
            {catalog_title}
            {go_to_year}
            {list_worksets}
        </ContentWrapper>
    }
}

export default EditCatalog;

